import { Maybe } from './maybe';

/* eslint-disable no-unused-vars */
export enum SalesforceObjectName {
  Celebration = 'flair__Celebration__c',
  WorkflowItem = 'flair__Workflow_Item__c',
  Absence = 'flair__Absence__c',
  Expense = 'flair__Expense__c',
  EmployeeCertificate = 'flair__Certificate_Association__c',
  CandidateEvaluation = 'flair__Candidate_Evaluation__c',
  Document = 'flair__Employee_Document__c',
  Inventory = 'flair__Inventory_Item__c',
  Ticket = 'flair__Ticket__c',
  Announcements = 'flair__Company_Announcement__c',
  TimeSheetDay = 'flair__Timesheet_Day__c',
  Candidate = 'flair__Candidate__c',
  EmployeeDataChangeRequest = 'flair__Employee_Data_Change_Request__c',
  ExpenseGroup = 'flair__Expense_Group__c',
  Job = 'flair__Job__c',
  ShiftChangeRequest = 'flair__Shift_Change_Request__c',
}

export const getSalesforceObjectName = (
  objectName: string,
): Maybe<SalesforceObjectName> => {
  return Object.values(SalesforceObjectName).includes(
    objectName as SalesforceObjectName,
  )
    ? (objectName as SalesforceObjectName)
    : null;
};

export const isSupportedObjectType = (objectName: string): boolean => {
  return getSalesforceObjectName(objectName) !== null;
};

// Temp solution until we enhance the get salesforce object name logic
// Fallback to append flair__ prefix and __c suffix if the object name is not recognized
export const getRelatedObjectNameWithFallback = (
  objectNameStr: string,
): SalesforceObjectName => {
  const recognizedObjectName = getSalesforceObjectName(objectNameStr);
  if (recognizedObjectName) {
    return recognizedObjectName;
  }

  if (objectNameStr.startsWith('flair__') && objectNameStr.endsWith('__c')) {
    return objectNameStr as SalesforceObjectName;
  }

  return `flair__${objectNameStr}__c` as SalesforceObjectName;
};
